import { render, staticRenderFns } from "./ProfileNav.vue?vue&type=template&id=5aecbe7e&scoped=true&"
import script from "./ProfileNav.vue?vue&type=script&lang=js&"
export * from "./ProfileNav.vue?vue&type=script&lang=js&"
import style0 from "./ProfileNav.vue?vue&type=style&index=0&id=5aecbe7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aecbe7e",
  null
  
)

export default component.exports